
import { 
  QueryDocumentSnapshot,
  FirestoreDataConverter,
  DocumentData,
  SnapshotOptions
} from "firebase/firestore";
import { Offer } from "@/types/offer";

// Firestore converter for Offer documents
export const offerConverter: FirestoreDataConverter<Offer> = {
  toFirestore(offer: Offer): DocumentData {
    // Ensure numDaysOverride and other fields are never undefined before saving to Firestore
    const sanitizedOffer = { ...offer };
    
    // Convert undefined to null for Firestore compatibility
    if (sanitizedOffer.numDaysOverride === undefined) {
      sanitizedOffer.numDaysOverride = null;
    }
    
    if (sanitizedOffer.priceCalc === undefined) {
      sanitizedOffer.priceCalc = null;
    }
    if ((sanitizedOffer as any).priceTier2Calc === undefined) {
      (sanitizedOffer as any).priceTier2Calc = null;
    }
    if ((sanitizedOffer as any).priceTier3Calc === undefined) {
      (sanitizedOffer as any).priceTier3Calc = null;
    }

    return sanitizedOffer;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options?: SnapshotOptions
  ): Offer {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      ...data
    } as Offer;
  }
};
